export const getClaimFormUrl = (brand: string, language: string) => {
   // SPAR
   if (brand == 'sparwindows')
      return 'https://share-eu1.hsforms.com/2dsAFYGpNSbeL_Nea9LDxew2denai';
   if (brand == 'sparvinduer')
      return 'https://share-eu1.hsforms.com/2O-k3LKmeTFi0g6dO_7ChQQ2denai';
   if (brand == 'sparokna')
      return 'https://share-eu1.hsforms.com/2ZHSi5cpfQ-yN1i195b9wcQ2denai';
   if (brand == 'sparkozijnen')
      return 'https://share-eu1.hsforms.com/2WT_XEUzxRWCGW9enR1p_-A2denai';
   if (brand == 'sparikkunat')
      return 'https://share-eu1.hsforms.com/2caVFuM8BQ0ulZw12DQt4zw2denai';
   if (brand == 'sparfönster')
      return 'https://share-eu1.hsforms.com/2SDaHGVBFSyak2-A_yL60Kg2denai';
   if (brand == 'sparevinduer')
      return 'https://share-eu1.hsforms.com/2x5isQToZSymhJuByR7sWRg2denai';

   if (brand == 'sparfenster') {
      if (language == 'de')
         return 'https://share-eu1.hsforms.com/2nPa-oKFxSSqf7CwHzdPtbQ2denai';
      if (language == 'at')
         return 'https://share-eu1.hsforms.com/2QnfdnBxTQaux0m_WxbaAaQ2denai';
   }
   // JNA
   if (brand == 'jna')
      return 'https://share-eu1.hsforms.com/2FQg-JgbuTHCyqj2aVItjFA2denai';

   // BB Yellow
   if (brand == 'bedst & billigst')
      return 'https://share-eu1.hsforms.com/2BZ6V7LHcRVKTYNUYKy3lzQ2denai';
   if (brand == 'best & billigst')
      return 'https://share-eu1.hsforms.com/2b4N_Q883Sxmt7iLhtsfsvg2denai';

   // GG
   if (brand == 'gut gunstig') {
      if (language == 'de')
         return 'https://share-eu1.hsforms.com/2TCSkufOjSb65ZLYccOrMZg2denai';
      if (language == 'at')
         return 'https://share-eu1.hsforms.com/2-ZCO7GAGTeCLHQKog8_wLg2denai';
   }

   // BB Red
   if (brand == 'bonusfönster')
      return 'https://share-eu1.hsforms.com/2C_NdWCgBSSeFV0u7TzaZVw2denai';
};
